export default "__VITE_ASSET__C26nF5zW__"